// extracted by mini-css-extract-plugin
export default {"SetCommissionPop":"SetCommissionPop_SetCommissionPop__zO29R","modalBody":"SetCommissionPop_modalBody__6HYTO"};